import React, {useState} from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { motion } from 'framer-motion';

const Feature = ({icon, title}) => {

    const [elementIsVisible, setElementIsVisible] = useState(false);

    const variant = {
        true: {
            transform: "scale(1)"
        },
        false: {
            transform: "scale(0.5)"
        }
    }

  return (
    <VisibilitySensor
        onChange={(isVisible) => setElementIsVisible(isVisible)}
        //minTopValue={100}
    >
        <div 
            className="feature flex flex-col items-center justify-start relative text-center mx-[12px]"
        >
            {/* Icon */}
            <motion.div 
                className="icon bg-[#081730] rounded-2xl p-4"
                variants={variant}
                animate={`${elementIsVisible}`}
                transition={{
                    duration: 1,
                    type: 'ease-out'
                }}
            >
                <img 
                    src={require(`../img/${icon}.png`)}
                    alt=''
                    className='w-[3rem]'
                />
            </motion.div>
            <span
                className='mt-[5px]'
            >
                {title}
            </span>
            <span
                className='text-[#707070] mt-[4px]'
            >
                Nunc Elementum, dolor vitae lacinia pulvinar, augue felis scelerisque libero, sit amet laoret lorem.
            </span>
            <span
                className='text-[#E600FF] underline mt-[3rem] hover:cursor-pointer'
            >
                Learn more
            </span>
        </div>
    </VisibilitySensor>
  )
}

export default Feature